import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StpRegistrationRenewReapplyService } from '../../services/stp-registration-renew-reapply.service';

@Component({
  selector: 'app-stp-action-history',
  templateUrl: './stp-action-history.component.html',
  styleUrls: ['./stp-action-history.component.scss'],
})
export class StpActionHistoryComponent implements OnChanges {
  actionHistoryList: any[] = [];
  currentPage = 1;
  pageSize = 5;

  @Input() stpMainId!: number;
  @Input() applicationId!: string;
  @Input() actionStatusFilter?: string;

  constructor(
    private stpRegistrationRenewReapplyService: StpRegistrationRenewReapplyService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stpMainId'] || changes['applicationId']) {
      this.getStpActionHistoryByInspectionId();
    }
  }

  getStpActionHistoryByInspectionId() {
    if (!this.stpMainId || !this.applicationId) {
      return;
    }

    this.stpRegistrationRenewReapplyService
      .getStpActionHistoryByStpMainId(this.stpMainId, this.applicationId)
      .subscribe({
        next: (res) => {
          if (res?.success) {
            const rows = Array.isArray(res?.data)
              ? res.data
              : res?.data
                ? [res.data]
                : [];

            this.actionHistoryList = this.actionStatusFilter
              ? rows.filter(
                  (item) =>
                    item?.actionStatus?.trim().toLowerCase() ===
                    this.actionStatusFilter?.trim().toLowerCase(),
                )
              : rows;

            this.currentPage = 1;
          }
        },
        error: (res) => {
          console.error('Error fetching history:', res);
        },
      });
  }

  isInspectionRollbacked(data: any): boolean {
    return data?.actionStatus === 'Inspection Rollbacked';
  }
}
